import { RIDES_KANBAN_DEFAULT_SORT } from "../../constants";
import { RidesKanbanSortEnum, type StorageKey } from "../../enums";
import type { TCompanyId } from "../../models";
import { localStorageHelpers } from "./storage.helpers";

const getRidesKanbanSortStorageKey = (companyId: TCompanyId): StorageKey =>
  `${companyId}_ridesKanbanSort`;

const isRidesKanbanSort = (value: unknown): value is RidesKanbanSortEnum =>
  Object.values<unknown>(RidesKanbanSortEnum).includes(value);

/** Falls back to the default when nothing is stored, or when a stored value is no longer a known option. */
export const getStoredRidesKanbanSort = (
  companyId: TCompanyId,
): RidesKanbanSortEnum => {
  const storedSort = localStorageHelpers.getItem<unknown>(
    getRidesKanbanSortStorageKey(companyId),
  );

  return isRidesKanbanSort(storedSort) ? storedSort : RIDES_KANBAN_DEFAULT_SORT;
};

export const storeRidesKanbanSort = ({
  companyId,
  sort,
}: {
  companyId: TCompanyId;
  sort: RidesKanbanSortEnum;
}): void => {
  localStorageHelpers.setItem(getRidesKanbanSortStorageKey(companyId), sort);
};
